import React from 'react';
import styles from './ListContent.module.scss';
import classNames from 'classnames';
import PaginationControls from './PaginationControls';
import { CircularProgress } from '@mui/material';

export interface ListContentProps<T extends { id: string }> {
  items: T[];
  titles: string[];
  EmptyStateComponent: React.FC;
  ItemComponent: React.FC<{ data: T }>;
  listHeaderClassName?: string;
  isLoading?: boolean;
  pagination?: {
    page: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    disabled?: boolean;
  };
}

const ListContent = <T extends { id: string }>({
  items,
  titles,
  ItemComponent,
  EmptyStateComponent,
  listHeaderClassName,
  isLoading = false,
  pagination,
}: ListContentProps<T>) => {
  if (isLoading) {
    return (
      <div className={styles.loading}>
        <div className={styles.loadingSpinner}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  if (!items.length) {
    return <EmptyStateComponent />;
  }

  return (
    <div className={styles.list}>
      <div className={classNames(styles.listHeader, listHeaderClassName)}>
        {titles.map((title, index) => (
          <div
            key={title}
            className={classNames(styles.tableTitle, {
              [styles.leftTableTitle]: index === 0,
            })}
          >
            {title}
          </div>
        ))}
      </div>
      {items.map((item) => (
        <ItemComponent data={item} key={item.id} />
      ))}
      {pagination && <PaginationControls {...pagination} />}
    </div>
  );
};

export default ListContent;
